// Images extension (admin side): the product page images.
// The tab is the old catalog editor's ImagesTab, reused as it is — it reads and
// writes through the shared catalog editor (../shared/catalog-editor.jsx).
import { PhotoIcon } from "@heroicons/react/24/outline"
import ImagesTab from "./ImagesTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"
import { reviewBadge } from "../shared/review-marks"

export const StoreProductExtension = {
  id: "images",
  label: "Images",
  description: "The original picture, the square, thumb and cover images and the screenshots",
  section: {
    component: catalogSection(ImagesTab),
    label: "Images",
    icon: PhotoIcon,
    // what a reviewer marked here for the vendor (shared/review-marks)
    badge: reviewBadge("images"),
    order: 300,
    visible: catalogVisible("images"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
